module.exports = __webpack_public_path__ + "static/media/CA_monocouche_pv_RTMAX_Suspente_RT_2020_11.62c3277a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CA_monocouche_pv_RTMAX_Suspente_RT_2020_11.jpg
// module id = 1147
// module chunks = 0